import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {AuthService} from './auth.service';
import {URL_PORTAL_SERVICOS_API} from '../util/constants';

@Injectable()
export class FederalizacaoService {

  constructor(
    private http: HttpClient,
    private authService: AuthService,
  ) { }

  get(): Promise<any> {
    const tokenBc = this.authService.getLocalTokenBrasilCidadao();
    return this.http.get(`${URL_PORTAL_SERVICOS_API}/federalizacao/secrets`, {headers: {
        AuthorizationSerpro: `${tokenBc}`
      }}).toPromise();
  }
}



// WEBPACK FOOTER //
// ./src/app/services/federalizacao.service.ts